/**
 * One-shot intent signal for ATOMIC {pill, page} roster navigations.
 *
 * useRosterStatusTabs resets pagination to page 1 on a pill change — correct
 * for user pill clicks, wrong for the deep-link resolver, which navigates
 * {tab, pill, page} together with a BE-computed landing page. Before/after
 * value-diffing cannot distinguish the two when the resolved page happens to
 * EQUAL the page the user was already on (review-caught: pill=script page 2 →
 * resolver targets pill=content page 2 → numeric diff reads "no page change" →
 * reset to 1, and the resolver's one-shot guard means no self-heal). So the
 * resolver declares its intent explicitly: it calls markAtomicRosterNav() right
 * before its navigate(), and the tabs hook consumes (or discards) the flag on
 * its next transition.
 *
 * Module-level state is deliberate: there is a single campaign-detail surface,
 * the flag lives for exactly one navigation commit, and threading it through
 * the URL or React context would leak a purely-internal handshake into public
 * API surface.
 */
let pendingAtomicNav = false;

/** Resolver-side: declare that the NEXT pill change carries its own page. */
export function markAtomicRosterNav(): void {
  pendingAtomicNav = true;
}

/** Read without clearing — safe during render (pure read, StrictMode-safe). */
export function peekAtomicRosterNav(): boolean {
  return pendingAtomicNav;
}

/** Read AND clear — called from the tabs hook's transition effect. Also used
 *  to discard a stale flag when a transition consumes nothing pill-related. */
export function consumeAtomicRosterNav(): boolean {
  const pending = pendingAtomicNav;
  pendingAtomicNav = false;
  return pending;
}
